import createSupabaseStore from './supabase-table-store'

export default projectId => createSupabaseStore(
  async (set, supabase, payload) => {
    const {data} = await supabase
      .from('project_category_leaderboard_view')
      .select('*')
      .eq('project_id', projectId)
    ;

    set(data);
  },
  ['scores', 'project_maps'],
  []
)